export default __webpack_public_path__ + "static/media/pexels-christina-morillo-1181346.b80823a8.png";